export const parameterizeArray = (key, arr) => {
    arr = arr.map(encodeURIComponent);
    return key + '[]=' + arr.join('&' + key + '[]=');
}

export const isInt = (value) => {
    var x;
    if (isNaN(value)) {
        return false;
    }
    x = parseFloat(value);
    return (x | 0) === x;
}

export const isVideo = (fileName) => {
    let fileExt = fileName.split('.').pop();

    if(fileExt == 'mp4'){
        return true
    }

    return false;
}
